<template>
	<div>
		<dms-dialog :dialog-mode="pageMode" :visible.sync="visibleCmp" :close-on-click-modal="closeOnPressEscape" :close-on-press-escape="closeOnPressEscape" hide-ok hide-cancel full-height :label="labelText" pdf
			@dialog-opened="dialogOpened" @dialog-closed="dialogClosed">
			<template slot="title">
				<dms-row :gutter="0" type="flex" justify="space-between" align="middle">
					<dms-col :lg="24" :md="24" :sm="24">
					<dms-col :lg="14" :md="8" :sm="8">
					<div class="el-dialog__title">
						{{ dialogTitleText }}
					</div>					
					</dms-col>
						<dms-col :lg="10" :md="16" :sm="16">						
						<div v-show="contentLoaded" class="action-buttons">
						<dms-col :lg="5" :md="5" :sm="6">
						<dms-check :disabled="false" :value.sync="isDownload">
							<i class="el-icon-download icon-size" />
						</dms-check>
						</dms-col>
						<dms-col :lg="5" :md="5" :sm="6">
						<dms-check v-if="enablePrintButton" :disabled="false" :value.sync="isPrint">
							<i class="el-icon-printer icon-size" />
						</dms-check>
						</dms-col>						
						<dms-col :lg="5" :md="5" :sm="6">					
						<dms-button type="primary" label-key="Ok" :disabled="false" @click="doActions" />
					</dms-col>
					</div>					
				</dms-col>
				</dms-col>
				</dms-row>
				
			</template>
			<div id="pdfContent" ref="pdfContent" slot="content">
				<pdf-document v-show="showPdfCmp" ref="pdfDocument" v-bind="{url, filter, fetchPdfProvider, scale, multipart}" :is-split-label-key="isSplitLabelKeyCmp"
					:content-loaded.sync="contentLoaded" :close-dialog-after-print-guard="closeDialogAfterPrintGuard"
					@onPrintDialogClosed="onPrintDialogClosed" @emailPdf="emailIt" @print-done="printPdf" />
				<slot name="content" />
			</div>
		</dms-dialog>
		<sms-email-modal v-show="visibleSmsEmailModal" :visible="visibleSmsEmailModal" :sms-disabled="true" :email-typ-pzn="29" :zakaznik-id="zakaznikId"
			:pdf="pdf" @update:visible="runActionsAfterPrint" />
	</div>
</template>

<script>
import { OpenerMixin } from '@/main/mixins/opener';
import SmsEmailModal from '@/modules/kartoteka/smsEmailModal/SmsEmailModal.vue';

import { DmsBaseComponent } from '#components/dms/common/base';

import PDFDocument from './pdf/PDFDocument.vue';

export default DmsBaseComponent.extend({
	name: 'DmsPdfDialog',
	mixins: [OpenerMixin],
	components: {
		'pdf-document': PDFDocument,
		SmsEmailModal,
	},
	props: {
		url: String,
		filter: Object,
		preventClose: { type: Boolean, default: false },
		visible: { type: Boolean, required: true },
		fetchPdfProvider: Function,
		showPdf: { type: Boolean, default: true },
		autofetch: { type: Boolean, default: true },
		zakaznikId: { type: Number, default: null },
		multipart: { type: Boolean, default: false },
		skipConfirm: { type: Boolean, default: false },
		isSplitLabelKey: { type: Boolean, default: false },
		isInvoicePdf: { type: Boolean, default: false }
	},
	data() {
		return {
			isPrint: true,
			isDownload: true,
			contentLoaded: false,
			isAnyError: false,
			scale: 1.5,
			visibleSmsEmailModal: false,
			pdf: null,
			multipartPdf: null,
		};
	},
	computed: {
		closeOnPressEscape() {
            return this.isInvoicePdf ? this.contentLoaded || this.isAnyError : !this.preventClose;
		},
		enablePrintButton() {
			return this.contentLoaded && (!this.multipart || (this.$refs.pdfDocument && (this.$refs.pdfDocument).singlePart));
		},
		visibleCmp: {
			get() {
				return this.visible;
			},
			set(val) {
				this.$emit('update:visible', val);
			},
		},
		showPdfCmp: {
			get() {
				return this.showPdf;
			},
			set(val) {
				this.$emit('update:showPdf', val);
			},
		},
		dialogTitleText() {
			return this.getText(this.label, this.labelKey, undefined, this.LocalizePopisostatni);
		},
		dialogStyle() {
			return this.showPdfCmp ? {} : {};
		},
		isSplitLabelKeyCmp() {
			return this.isSplitLabelKey;
		},
	},
	mounted() {
		this.visible && this.autofetch && this.$nextTick(() => { this.fetchPdf(); });
	},
	methods: {
		async doActions() {			
			if (this.isPrint) {
				this.printIt();
				this.visibleCmp = false;
				this.$emit('print-done', false);
			}
			if (this.isDownload) {
				this.exportIt();
			}
		},
		runActionsAfterPrint() {
			this.visibleSmsEmailModal = false;
			if (this.isPrint) {
				this.printIt();
			}
			if (this.isDownload) {
				this.exportIt();
			}
		},
		printIt() {
			this.$refs.pdfDocument.printPdf();
			this.printPdf();
		},
		exportIt() {
			this.$refs.pdfDocument.savePdf();
		},
		async emailIt(pdf = null) {
			if (pdf && !pdf.target) { // if its not MouseEvent
				this.multipartPdfs = this.pdf;
				this.pdf = pdf;
			} else if (this.multipartPdfs && !pdf) {
				this.pdf = this.multipartPdfs;
			}
			this.visibleSmsEmailModal = true;
			return true;
		},
		async fetchPdf() {
			if (this.multipart) {
				this.pdf = await this.$refs.pdfDocument.fetchMultipartPdf(this.filter);
			} else {
				this.pdf = await this.$refs.pdfDocument.fetchPdf(this.filter);
			}
			if (!this.pdf) {
				this.$emit('update:visible', false);
			}
		},
		dialogOpened() {
			this.autofetch && this.fetchPdf();
		},
		dialogClosed() {
			this.$refs.pdfDocument.cleanCanvas();
			this.contentLoaded = false;
			this.isAnyError = false;
			this.$emit('dialog-closed');
		},
		async onPrintDialogClosed() {
			this.visibleCmp = false;
			this.$emit('printed');
			this.$emit('printDialogClosed');
		},
		async closeDialogAfterPrintGuard() {
			if (!this.isPrint) {
				return true;
			}

			const questionResult = this.skipConfirm || await this.showConfirm({
				message: this.LocalizeChyboveHlasky('AskForTisk'),
				title: this.LocalizeChyboveHlasky('questionTitle'),
				options: {
					confirmButtonText: this.Localize('Ano'),
					cancelButtonText: this.Localize('Ne'),
				},
			});

			return questionResult;
		},
		printPdf() {
			this.$emit('print-done', true);
		},
	},
});
</script>

<style lang="scss">
#pdfContent {
	height: 100%;
	width: 100%;
}

.icon-size {
	font-size: 22px !important;
}
</style>
